import { apiRequest } from "@/api";

const state = {
  connected: !!window.localStorage.getItem("JWT"),
  token: window.localStorage.getItem("JWT"),
  storeId: window.localStorage.getItem("storeId"),
  super_actions: window.localStorage.getItem("cleed_secret_actions"),
  admin_i18n: {},
  admin_details: undefined,
};

const mutations = {
  SET_SIGNED_IN: (state, { token, storeId }) => {
    state.connected = true;
    state.token = token;
    state.storeId = storeId;
    window.localStorage.setItem("JWT", state.token);
  },
  SET_SIGNED_OUT: (state) => {
    state.connected = false;
    state.token = undefined;
    state.storeId = undefined;
    window.localStorage.removeItem("JWT");
    window.localStorage.removeItem("JWTA");
    window.localStorage.removeItem("cleed_secret_actions");
    window.localStorage.removeItem("messangerType");
    window.localStorage.removeItem("msgTrackingState");
  },
  SET_I18N: (state, { response }) => {
    state.admin_i18n = response[0].admin_i18n;
  },
  UPDATE_I18N: (state, data) => {
    state.admin_i18n = data;
  },
  SET_DETAILS: (state, data) => {
    state.admin_details = data.response[0];
  },
  UPDATE_AGENTS: (state, data) => {
    state.admin_details.agents = data.agents;
  },
};

const actions = {
  SIGN_IN: ({ commit, dispatch }, { email, password }) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .post("admin/signin", { email, password })
        .then(({ data }) => {
          if (data.success && data.token) {
            commit("SET_SIGNED_IN", {
              token: data.token,
              storeId: "" + data.store_id,
            });
            window.localStorage.setItem("storeId", data.store_id);
          }
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  SIGN_OUT: ({ commit }) => {
    commit("SET_SIGNED_OUT");
    window.location.href = "/";
  },
  Unauthorized: ({ commit }) => {
    commit("SET_SIGNED_OUT");
  },
  FETCH_ADMIN_USERS: async ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("admin/admin_user_details")
        .then(({ data }) => {
          commit("SET_DETAILS", data);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  FETCH_ADMIN_I18N: async ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("admin/cleed_admin_i18n")
        .then(({ data }) => {
          commit("SET_I18N", data);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  UPDATE_ADMIN_I18N: ({ commit }, json) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("admin/Update_admin_i18n", json)
        .then(() => {
          commit("UPDATE_I18N", json);
          resolve(json);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  UPDATE_STORE_EMAIL_DETAILS: ({ state }, json) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("admin/Update_store_email_details", json)
        .then(() => {
          state.admin_details.details = json;
          resolve(json);
        })

        .catch((e) => {
          reject(e);
        });
    });
  },
  UPDATE_STORE_EMAIL_FORMAT: ({ state }, { data, type, lang, CC }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("admin/Update_store_email_format", { data, type, lang, CC })
        .then(() => {
          if (CC) {
            state.admin_details.details.EmailApi.content[type].cc = CC;
          } else {
            state.admin_details.details.EmailApi.content[type][lang] = data;
          }
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  UPDATE_ADMIN_AGENTS: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      console.log(params);
      apiRequest()
        .post("admin/admin-agents", params)
        .then(({ data }) => {
          commit("UPDATE_AGENTS", data);
          resolve(data);
        })
        .catch((err) => reject(err));
    }),
  DELETE_ADMIN_AGENT: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .delete(`admin/admin-agents?agent=${params}`)
        .then(({ data }) => {
          commit("UPDATE_AGENTS", data);
          commit("UPDATE_MESSAGES_AGNET", params);
          resolve(data);
        })
        .catch((err) => reject(err));
    }),

  UPDATE_EMAIL_LIST: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .post("admin/email_list", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    }),

  DELETE_ALL_EMAIL_LIST: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .delete("admin/email_list/all", { data: params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    }),

  DELETE_EMAIL_LIST: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .delete(`admin/email_list/${params.listType}/${params.user}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    }),

  UPDATE_STORE_CONFIG_DETAILS: ({ state }, json) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("admin/Update_store_config_details", json)
        .then(() => {
          state.admin_details.details = json;
          resolve(json);
        })

        .catch((e) => {
          reject(e);
        });
    });
  },
};

export default { state, mutations, actions };
